import { render, staticRenderFns } from "./TemplateGeneratorComponent.vue?vue&type=template&id=07dcaba2&scoped=true&lang=pug"
import script from "./TemplateGeneratorComponent.vue?vue&type=script&lang=ts"
export * from "./TemplateGeneratorComponent.vue?vue&type=script&lang=ts"
import style0 from "./TemplateGeneratorComponent.vue?vue&type=style&index=0&id=07dcaba2&lang=scss&scoped=true"
import style1 from "./TemplateGeneratorComponent.vue?vue&type=style&index=1&id=07dcaba2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dcaba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07dcaba2')) {
      api.createRecord('07dcaba2', component.options)
    } else {
      api.reload('07dcaba2', component.options)
    }
    module.hot.accept("./TemplateGeneratorComponent.vue?vue&type=template&id=07dcaba2&scoped=true&lang=pug", function () {
      api.rerender('07dcaba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/TemplateGenerator/TemplateGeneratorComponent.vue"
export default component.exports